import SnackbarUtils from 'src/utils/SnackbarUtils';
import { useDispatch } from 'react-redux';
import { Button, Dialog, Grid } from 'src/components';
import VtysGrupEnum from 'src/enums/VtysGrupEnum';
import RolDbAutoComplete from 'src/parts/Yetki/RolDbAutoComplete';
import { useLazyGetDepoInfoByIdQuery } from 'src/services/StokEczane/DepoDonemApi';
import { useAppSelector } from 'src/store';
import DepoTanimSlice from 'src/store/Slices/StokEczane/DepoTanimSlice';
import { useNavigate } from 'react-router';
import DialogTitle from 'src/components/DialogTitle';
import DialogActions from 'src/components/DialogActions';
import DialogContent from 'src/components/DialogContent';
import { translate } from 'src/i18n/tHelper';
import { useState } from 'react';
import VwStkDepodonemDTO from 'src/models/StokEczane/DepoDonemleri/VwStkDepodonemDTO';

const translatePath = "pages|stokeczane|yetkiislemleri|deposecimdialog"

const DepoSecimDialog = (): JSX.Element => {
  const navigate = useNavigate();
  const [getDepoInfo, getDepoInfoState] = useLazyGetDepoInfoByIdQuery();
  const dispatch = useDispatch();
  const selectedDepoId = useAppSelector((x) => x.DepoTanim.selectedDepo.depoTanimId);
  const [activeDepo, setActiveDepo] = useState<VwStkDepodonemDTO>(new VwStkDepodonemDTO());

  const rolDbChangeHandler = (e) => {
    if (e.target?.value) {
      getDepoInfo({ tanimId: e.target.value })
        .unwrap()
        .then(response => {
          setActiveDepo(response)
        })
        .catch(e => e);
    }
  };
  return (
    <Dialog open={true} fullWidth maxWidth="sm">
      <DialogTitle>{translate(translatePath, 'Depo Seçim')}</DialogTitle>
      <DialogContent>
        <Grid container style={{ paddingTop: 10, paddingLeft: 15 }}>
          <Grid item xs={12}>
            <RolDbAutoComplete
              value={selectedDepoId}
              vtysgrup={VtysGrupEnum.depoTipleri}
              onChange={rolDbChangeHandler}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          customType="save"
          onClick={() => {
            if (getDepoInfoState.data)
              dispatch(
                DepoTanimSlice.actions.setSelectedDepo(
                  getDepoInfoState?.data
                )
              );
            SnackbarUtils.success(
              translate(translatePath,
                'Depo seçimi başarıyla tamamlandı.Depo işlemlerinize ' +
                getDepoInfoState?.data?.depoAdi +
                ' isimli depo ile devam edebilirsiniz.'
              )
            );
            dispatch(
              DepoTanimSlice.actions.setIsDepoSecimDialogOpen(false)
            );
          }}
          disabled={!(activeDepo.id > 0) || getDepoInfoState.isFetching}
        />
        <Button
          customType="close"
          onClick={() => {
            dispatch(
              DepoTanimSlice.actions.setIsDepoSecimDialogOpen(false)
            );
            navigate('/duyuru');
          }}
        />
      </DialogActions>
    </Dialog>
  );
};

export default DepoSecimDialog;
